import { handleAdminQuantityDefinitionCategoryCreated } from "./admin";
import { handleUserQuantityDefinitionCategoryCreated } from "./user";


export function createQuantityDefintionCategory(state, patch) {

    const { visibility, payload } = patch;
    if (patch.visibility === "admin") {
        return handleAdminQuantityDefinitionCategoryCreated(state, payload);
    }

    return handleUserQuantityDefinitionCategoryCreated(state, payload);
}